import React, { ReactElement, useState } from 'react';
import { SearchResults, SingleSelect } from 'idsk-react-components';
import { ExpansionPanel, useResponsiveContext } from 'slovlex-idsk-react-components';
import { TypCiselnikaEnum } from 'ciselniky-frontend-ts-axios';
import CiselnikPolozka from '../../../model/CiselnikPolozka';
import { SafeParameterSetter } from '../../../types/SafeParameterSetter';
import { PravoEuFilter } from '../../../model/PravoEuFilter';
import useSearchValidPolozkyCiselnik
  from '../../NavrhAktuEuList/hooks/useSearchValidPolozkyCiselnik';
import {
  MAX_MULTISELECT_RESULT, SHOW_ALL_MAX_RESULT,
} from '../../../constants/MultiSelectConstant';

interface Props {
  onUpdateField: SafeParameterSetter<PravoEuFilter>;
  onUpdateFieldCopy: SafeParameterSetter<PravoEuFilter>;
  filter: PravoEuFilter;
  filterCopy: PravoEuFilter;
}

const AutorSingleSelect = ({
  onUpdateField,
  onUpdateFieldCopy,
  filter,
  filterCopy,
}: Props): ReactElement => {
  const [searchText, setSearchText] = useState('');
  const [showList, setShowList] = useState<boolean>(false);
  const [limit, setLimit] = useState(MAX_MULTISELECT_RESULT);
  const { isSmallScreen } = useResponsiveContext();

  const {
    polozkyCiselnik,
    polozkyCiselnikStatus,
  } = useSearchValidPolozkyCiselnik(
    {
      kody: null,
      typy: [TypCiselnikaEnum.Institucia],
      ids: [],
      platny: true,
      hladanyNazov: filterCopy?.autor?.nazov || searchText,
      limit,
    },
  );

  const handleSelectedItemChange = (item: CiselnikPolozka): void => {
    setShowList(false);
    if (item) {
      onUpdateField('autor', item);
    }
    onUpdateFieldCopy('autor', item);
  };

  return (
    <ExpansionPanel title="Autor" isExpanded={!!filter.autor && !isSmallScreen}>
      <div className="slovlex-idsk-side-panel-input-wrapper single-select-input-wrapper">
        <SingleSelect
          id="autorSingleSelect"
          name="autorSingleSelect"
          searchText={searchText || ''}
          setSearchText={(text) => {
            setSearchText(text);
            setLimit(MAX_MULTISELECT_RESULT);
          }}
          selectedItem={filterCopy.autor || null}
          setSelectedItem={handleSelectedItemChange}
          selectedItemValue={filter.autor?.nazov || ''}
          visibilityMinSearchLength={0}
          showList={showList}
          setShowList={setShowList}
        />
        <SearchResults
          loadingShowAll={polozkyCiselnikStatus.loading}
          className="single-select-fazet"
          handleShowAll={() => {
            setLimit(SHOW_ALL_MAX_RESULT);
          }}
          withShowAllButton={(limit === MAX_MULTISELECT_RESULT
              && polozkyCiselnik.length === MAX_MULTISELECT_RESULT)
            || (limit === SHOW_ALL_MAX_RESULT && polozkyCiselnik.length <= MAX_MULTISELECT_RESULT)}
          setSearchText={(text) => {
            setSearchText(text);
            setLimit(MAX_MULTISELECT_RESULT);
          }}
          data={polozkyCiselnik}
          setSelectedItem={handleSelectedItemChange}
          dataAttributesToShow={[{ key: 'nazov', label: '' }]}
          type="column"
          size="m"
          visible={searchText.trim().length > 0 || showList}
        />
      </div>
    </ExpansionPanel>
  );
};

export default AutorSingleSelect;
